import { createContext, useContext } from 'react';

import { ITimelineContextProviderProps, ITimelineContext } from './types';

const TimelineContext = createContext<ITimelineContext>({
  timelineDays: null,
  isTripEventsChanged: false,
  validationErrors: null,
  hasValidationErrors: false,
  isSubmitting: false,
  selectedEvents: [],
  setSelectedEvents: () => {},
  handleSave: () => {},
  handleNext: () => {},
});
export const useTimelineContext = () => useContext(TimelineContext);

export const TimelineContextProvider = ({ value, children }: ITimelineContextProviderProps) => {
  return <TimelineContext.Provider value={value}>{children}</TimelineContext.Provider>;
};
